<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
    v-if="role('safetyRepresentative')"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small class="primary accent-4 white--text mr-2 my-1">
        {{ $t(`profile.personalInformation.title`) }}
      </v-btn>
    </template>

    <v-card v-if="personalInformation">
      <v-card-title class="headline grey lighten-2" primary-title>{{
        $t(`profile.personalInformation.title`)
      }}</v-card-title>

      <v-card-text>
        <v-text-field
          v-model="personalInformation.personalCode"
          :label="$t('profile.personalInformation.personalCode')"
        />
        <v-slide-y-transition>
          <v-alert
            v-if="isPersonalCodeMatchingHealthCheck"
            type="warning"
            color="orange"
            dense
            class="mt-n3"
          >
            <v-row align="center" no-gutters>
              <v-col>
                <span>
                  {{ $t("profile.personalInformation.linkHealthCheck") }}
                </span>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  @click="linkHealthCheckResult"
                  class="ml-2"
                >
                  {{ $t("dialog.add") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-slide-y-transition>
        <v-text-field
          v-model="personalInformation.address"
          :label="$t('profile.personalInformation.address')"
        />
        <v-text-field
          v-model="personalInformation.phone"
          :label="$t('profile.personalInformation.phone')"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>

        <template>
          <v-btn color="grey" text @click="hide">{{
            $t("dialog.cancel")
          }}</v-btn>
          <v-btn color="primary" text @click="save" :loading="loading">{{
            $t("dialog.save")
          }}</v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import PersonalInformationQuery from "@/graphql/queries/PersonalInformation.gql";
import ResultsWithoutHealthCheckQuery from "@/graphql/queries/healthCheck/ResultsWithoutHealthCheck.gql";
import ChangePersonalInformation from "@/graphql/mutation/profile/ChangePersonalInformation.gql";
import LinkHealthCheckResultMutation from "@/graphql/mutation/healthCheck/LinkHealthCheckResult.gql";

export default {
  props: ["id"],

  data() {
    return {
      show: false,
      personalInformation: {
        personalCode: "",
        address: "",
        phone: "",
      },
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["role"]),
    isPersonalCodeMatchingHealthCheck() {
      return (
        this.resultsWithoutHealthCheck &&
        this.personalInformation &&
        this.resultsWithoutHealthCheck.some(
          (healthCheck) =>
            healthCheck.personalCode === this.personalInformation.personalCode
        )
      );
    },
  },

  methods: {
    hide() {
      this.show = false;
    },

    save() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ChangePersonalInformation,
          variables: {
            employeeId: this.id,
            personalInformation: this.personalInformation,
          },
        })
        .then(() => {
          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    linkHealthCheckResult() {
      this.$apollo
        .mutate({
          mutation: LinkHealthCheckResultMutation,
          variables: {
            employeeId: this.id,
            resultId: this.resultsWithoutHealthCheck.find(
              (result) =>
                result.personalCode === this.personalInformation.personalCode
            ).id,
          },
        })
        .then(() => {
          this.resultsWithoutHealthCheck = this.resultsWithoutHealthCheck.filter(
            (result) =>
              result.personalCode !== this.personalInformation.personalCode
          );
          this.save();
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            text: err,
            color: "error",
          });
        });
    },
  },

  apollo: {
    personalInformation: {
      query: PersonalInformationQuery,
      variables() {
        return {
          id: this.id,
        };
      },
      update(data) {
        return { ...data.employee.personalInformation };
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "network-only",
    },
    resultsWithoutHealthCheck: {
      query: ResultsWithoutHealthCheckQuery,
      skip() {
        return !this.show;
      },
    },
  },
};
</script>

<style>
input {
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
